import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import BluebirdPromise from 'bluebird';
import cns from 'classnames';
import { reduxForm, getFormValues, change, isDirty } from 'redux-form';
import CustomHomeSection from './CustomHome/CustomHomeSection';
import VerbButton, { VERB_BUTTON_TYPE } from '../../../../../shared/components/VerbButton';
import FormFeedback from '../../../../../shared/components/formComponents/FormFeedback';
import { getManyGlobalContentRows } from '../../../../../shared/actions';
import { getManyCollections } from '../../../../../shared/actions/Collections';
import { makeGetObjectsFromStateById } from '../../../../../shared/selectors';
import { filterCollectionsForCompany } from '../../../../../shared/utils/CollectionUtils';
import { RuntimeContext } from '../../../../../../common/RuntimeContext';
import { DEFAULT_CUSTOM_DISCOVER_PAGE } from '../../../../../shared/Constants';

class CompanyCustomLayoutsForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedTab: 'customDiscover'
        };
    }

    static propTypes = {
        availableCollections: PropTypes.array,
        changeFormValue: PropTypes.func,
        currentFormValues: PropTypes.object,
        handleSubmit: PropTypes.func,
        onCancel: PropTypes.func,
        submitting: PropTypes.bool,
        error: PropTypes.object,
        getManyCollections: PropTypes.func,
        getManyGlobalContentRows: PropTypes.func,
        currentCompany: PropTypes.object,
        dirty: PropTypes.bool,
        toggleShowUnsavedChangesPrompt: PropTypes.func,
        globalCollectionRowOptions: PropTypes.array
    };

    static contextType = RuntimeContext

    componentDidMount() {
        const { getManyCollections, getManyGlobalContentRows } = this.props;
        return BluebirdPromise.all([getManyCollections({pathsContext: this.context.pathsWeb}), getManyGlobalContentRows({pathsContext: this.context.pathsWeb})]);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.dirty !== this.props.dirty) {
            return this.props.toggleShowUnsavedChangesPrompt(this.props.dirty);
        }
        return null;
    }

    restoreDefaults(selectedTab) {
        const { changeFormValue } = this.props;
        changeFormValue({ field: selectedTab, value: { categories: DEFAULT_CUSTOM_DISCOVER_PAGE.categories } });
    }

    renderLayoutOptions() {
        const {
            availableCollections,
            changeFormValue,
            currentFormValues = {},
            handleSubmit,
            onCancel,
            submitting,
            error,
            globalCollectionRowOptions
        } = this.props;
        const { selectedTab } = this.state;

        return (
            <div className={'company-custom-layouts-form'}>
                <form className={'companyForm'}>
                    <div className={'company-collection-section'}>
                        <CustomHomeSection
                            customTab={selectedTab}
                            collectionOptions={availableCollections}
                            changeFormValue={changeFormValue}
                            currentFormValues={currentFormValues}
                            globalCollectionRowOptions={globalCollectionRowOptions}
                        />
                    </div>
                    {!!(currentFormValues[selectedTab] && currentFormValues[selectedTab]?.categories?.length) && (
                        <div className={'col-12 restore-row'}>
                            <a className={'restore-link'} onClick={this.restoreDefaults.bind(this, selectedTab)}>
                                Restore Defaults
                            </a>
                        </div>
                    )}
                    <div className={'col-12 formButtons'}>
                        <VerbButton
                            fontAwesomeIcon={'fa-save'}
                            textId={'BUTTON_SAVE'}
                            defaultMessage={'SAVE'}
                            onClick={(values) => {
                                handleSubmit(values);
                            }}
                            disabled={submitting}
                        />
                    </div>
                    <FormFeedback failMsg={error} className={'col-12'} {...this.props} />
                </form>
            </div>
        );
    }

    render() {
        const { selectedTab } = this.state;
        return (
            <>
                {this.renderLayoutOptions()}
            </>
        );
    }
}

export { CompanyCustomLayoutsForm as CompanyCustomLayoutsFormComponent };
const getCompanyFormValues = getFormValues('CompanyLayouts');
const makeMapStateToProps = () => {
    const getCollectionsFromStateById = makeGetObjectsFromStateById('collections');
    return (state, ownProps) => {
        const {
            customDiscover = {
                categories: []
            },
            customHome = {
                categories: []
            }
        } = ownProps.company;
        const allCollections = getCollectionsFromStateById(state);
        const availableCollections = filterCollectionsForCompany(allCollections, ownProps.company);
        const globalCollectionRowOptions = state?.globalContentRows?.byId || {};

        return {
            dirty: isDirty('CompanyLayouts'),
            initialValues: {
                customDiscover: {
                    categories: (customDiscover.categories.length > 0) ? customDiscover.categories : DEFAULT_CUSTOM_DISCOVER_PAGE.categories
                },
                customHome
            },
            currentCompany: ownProps.company,
            availableCollections,
            globalCollectionRowOptions,
            currentFormValues: getCompanyFormValues(state)
        };
    };
};

const mapDispatchToProps = (dispatch) => ({
    changeFormValue: (params) => dispatch(change('CompanyLayouts', params.field, params.value)),
    getManyCollections: (params) => dispatch(getManyCollections(params)),
    getManyGlobalContentRows: (params) => dispatch(getManyGlobalContentRows(params))
});

export default compose(
    connect(makeMapStateToProps, mapDispatchToProps),
    reduxForm({
        form: 'CompanyLayouts',
        destroyOnUnmount: false,
        enableReinitialize: true
    })
)(CompanyCustomLayoutsForm);
